import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Grid,
	makeStyles,
	Theme,
	Typography
} from "@material-ui/core";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import Section, { SectionProps } from "../Section";
import { useState } from "react";

addRegisteredSectionLayout({
	name: "ExpandableSummarySection",
	displayName: "ExpandableSummarySection",
	settings: {
		editableOptions: {}
	}
});

const useStyles = makeStyles(
	(theme: Theme) => ({
		root: {
			margin: "0 auto",
			padding: theme.spacing(1),
			maxWidth: "550px"
		},
		sectionTitle: {
			padding: 4 // To simulate padding from <Section /> where fields have spacing={1} -> giving 4px padding
		},
		boldExpansionTitle: {
			fontWeight: "bold"
		},
		expandIcon: {
			color: theme.palette.primary.main,
			fontSize: 32
		},
		collapsedSummary: {
			backgroundColor: "#fff",
			border: "1px solid #000",
			borderRadius: theme.shape.borderRadius
		},
		expandedAccordion: {
			backgroundColor: theme.palette.primary.light,
			borderRadius: theme.shape.borderRadius,
			border: `1px solid ${theme.palette.secondary.light}`
		}
	}),
	{ name: "DployExpandableSummarySection" }
);

interface ExpandableSummarySectionProps extends SectionProps {}

export const ExpandableSummarySection = (
	props: ExpandableSummarySectionProps
) => {
	const {
		expandInitially = false,
		boldExpansionTitle = false,
		sectionTitle,
		...rest
	} = props;

	const classes = useStyles(props);
	const [expanded, setExpanded] = useState(expandInitially);

	return (
		<Grid className={classes.root}>
			<Accordion
				expanded={expanded}
				className={clsx({ [classes.expandedAccordion]: expanded })}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
					id={props.sectionTemplateId?.toString()}
					className={clsx({ [classes.collapsedSummary]: !expanded })}
					onClick={() => setExpanded(!expanded)}
				>
					<Typography
						className={clsx(classes.sectionTitle, {
							[classes.boldExpansionTitle]: boldExpansionTitle
						})}
					>
						{sectionTitle}
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Section {...rest} />
				</AccordionDetails>
			</Accordion>
		</Grid>
	);
};
